module.exports = "https://health.dajiuxing.com.cn/img/assets/login/Accounticon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Flogin%2FAccounticon.png
// module id = skBF
// module chunks = 93